/**
 * Not Found Page (404)
 *
 * Shown when a requested page doesn't exist.
 */

import { useNavigate } from 'react-router-dom';
import { FileQuestion, ArrowLeft, Home } from 'lucide-react';

import { Button } from '@/components/common/Button';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background dark:bg-background-dark p-4">
      <div className="text-center max-w-md">
        {/* Icon */}
        <div className="flex justify-center mb-6">
          <div className="rounded-full bg-secondary-100 dark:bg-secondary-800 p-6">
            <FileQuestion className="h-16 w-16 text-secondary-500" />
          </div>
        </div>

        {/* Error code */}
        <h1 className="text-7xl font-bold text-foreground dark:text-foreground-dark mb-2">404</h1>

        {/* Title */}
        <h2 className="text-2xl font-semibold text-foreground dark:text-foreground-dark mb-4">
          Page Not Found
        </h2>

        {/* Description */}
        <p className="text-foreground-muted dark:text-foreground-dark-muted mb-8">
          The page you&apos;re looking for doesn&apos;t exist or has been moved. Please check the
          URL or navigate back to safety.
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            variant="outline"
            onClick={() => navigate(-1)}
            leftIcon={<ArrowLeft className="h-4 w-4" />}
          >
            Go Back
          </Button>
          <Button
            variant="primary"
            onClick={() => navigate('/dashboard')}
            leftIcon={<Home className="h-4 w-4" />}
          >
            Go to Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
}
